const getMessage = (state) => {
    return state.message
}

const getArchetypeCostumerUserCreated = (state) => {
    return state.customer_user_created
}

const getArchetypeActivatedAgent = (state) => {
    return state.customer_activated_agent
}

const getArchetypeVendorUserCreated = (state) => {
    return state.vendor_user_created
}

const getArchetypRequestInstitution = (state) => {
    return state.request_institution
}

export default {
    getMessage,
    getArchetypeCostumerUserCreated,
    getArchetypeActivatedAgent,
    getArchetypeVendorUserCreated,
    getArchetypRequestInstitution,
}
